import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import Dialog from '~components/Dialog/Dialog';
import DialogActions from '~components/Dialog/DialogActions';
import DialogContent from '~components/Dialog/DialogContent';
import DialogHeader from '~components/Dialog/DialogHeader';
import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';

interface SkipAddonsConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function SkipAddonsConfirmationDialog({
  open,
  onClose,
  onConfirm,
}: SkipAddonsConfirmationDialogProps) {
  return (
    <Dialog isOpen={open} onClose={onClose} maxWidth="xs">
      <DialogHeader onClose={onClose}>
        {t('approvals.driver_pay.settlements.skip_addons_dialog.title')}
      </DialogHeader>

      <DialogContent>
        <Typography variant="body2">
          {t('approvals.driver_pay.settlements.skip_addons_dialog.message')}
        </Typography>
      </DialogContent>

      <DialogActions>
        <SmallButton variant="outlined" color="secondary" onClick={onClose}>
          {t('approvals.driver_pay.settlements.skip_addons_dialog.cancel_button_text')}
        </SmallButton>
        <SmallButton variant="contained" color="primary" onClick={onConfirm}>
          {t('approvals.driver_pay.settlements.skip_addons_dialog.confirm_button_text')}
        </SmallButton>
      </DialogActions>
    </Dialog>
  );
}
